<template lang="pug">
  lei-modal(v-if="showIssuerModal", @close="toggleIssuerModal(false)", title="Lei Issuer")
    table-collapse.container(
    :table-data="leiIssuerDataOfCurrentEntity",
    title="Lei Issuer Details",
    @toggle="toggleTable",
    :show-content="showTable")
</template>
<script>
import { mapState, mapGetters, mapMutations, } from 'vuex'
import { TOGGLE_ISSUER_MODAL, } from '../../store/modules/record/mutations-types'
import LeiModal from '../lei-components/LeiModal'
import TableCollapse from '../record-details/table-components/TableCollapse'

export default {
  components: {
    TableCollapse,
    LeiModal,
  },
  data () {
    return {
      showTable: true,
    }
  },
  computed: {
    ...mapState('record', [ 'showIssuerModal', ]),
    ...mapGetters('record', [ 'leiIssuerDataOfCurrentEntity', ]),
  },
  methods: {
    toggleTable (val) {
      this.showTable = !val
    },

    ...mapMutations('record', {
      toggleIssuerModal: TOGGLE_ISSUER_MODAL,
    }),
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../assets/styles/variables.styl"
</style>



// WEBPACK FOOTER //
// src/components/modals/LeiIssuerModal.vue